
import { BaseModel } from "./base.model";
export class RRIMNiagaModel extends BaseModel {
  auto_id?: number;
  berat: any;
  beratKering: any;
  drc: any;
  harga: any;
  jenisGetah: any;
  licenseNo: any;
  nama: any;
  negeri: any;
  noIc: any;
  noPatG: any;
  noResit: any;
  pelesen: any;
  tarikh: any;
  year: any;
  month: any;
}
